import React from 'react';
import PropTypes from 'prop-types';
import { payoutStatus, itemCategory } from './PayoutsUtils';
import { get } from 'lodash';
import classnames from 'classnames';
import moment from 'moment';
import { injectIntl, intlShape, FormattedMessage, FormattedDate } from 'react-intl';

const PendingPayoutsRow = ({ payout, isCollapseOpen, intl }) => {
  const {
    date_modified = '',
    booking = {}
  } = payout;
  const totalAmount = get(payout, 'amount.display_string', '');
  const arrow = classnames('ico ico-sm icon-arrow-nav text-gray-500', { 'icon-rotate-180': isCollapseOpen });
  const status = get(payoutStatus, [payout.status], {});
  const bookingEndDate = get(booking, 'dts_end', '');
  const category = get(itemCategory, [payout.category], {});
  const firstName = get(payout, 'guest.name.first', '');
  const lastName = get(payout, 'guest.name.last', '');
  const useType = get(payout, 'listing.use_type', '');

  return (
    <div className="flex">
      <div className="flex-basis-15 hidden-xs margin-md-right">
        <FormattedDate
          value={moment.utc(date_modified).local()}
          year="numeric"
          month="long"
          day="2-digit"
        />
      </div>
      <div className="flex-basis-15 flex-basis-25-sm flex-basis-45-xxs">
        <span className={`status-${status.class}`}>{intl.formatMessage(status.text)}</span>
      </div>
      <div className="flex-basis-35 hidden-xxs flex middle">
        <img alt={intl.formatMessage(category.alt)} className="margin-md-right ico" src={`/web-hosting/assets/images/${category.icon}.svg?v=rb`} />
        <FormattedMessage id="hosting.pending_payouts_row.label" defaultMessage="{category} for {firstName} {lastName}'s {useType}" values={{ category: intl.formatMessage(category.text), firstName: firstName, lastName: lastName, useType: useType.toLowerCase().replace('-', '') }} />
      </div>
      <div className="flex-basis-15 text-right visible-lg">
        <FormattedDate
          value={moment(bookingEndDate)}
          year="numeric"
          month="long"
          day="2-digit"
        />
      </div>
      <div className="flex-basis-15 flex-basis-20-sm flex-basis-45-xxs text-right heavy">
        {totalAmount}
      </div>
      <div className="flex-basis-5 flex-basis-10-xxs text-right">
        <i className={arrow} />
      </div>
    </div>
  );
};

PendingPayoutsRow.propTypes = {
  payout: PropTypes.object.isRequired,
  isCollapseOpen: PropTypes.bool,
  intl: intlShape
};

export default injectIntl(PendingPayoutsRow);
